import axios from "axios";
import { API_URL } from '../Constants';

const adminURL = `${API_URL}/admin`;

class AdminService {
    // TENANTS
    getTenants = async (apiToken, filterObject) => {
        return axios.post(`${adminURL}/tenants`, filterObject, { headers: { Authorization: `Bearer ${apiToken}` }});
    };

    // USERS
    getUsers = async (apiToken, filterObject) => {
        return axios.post(`${adminURL}/users`, filterObject, { headers: { Authorization: `Bearer ${apiToken}` }});
    };

    // TENANT BILLINGS
    getTenantBillings = async (apiToken, filterObject) => {
        return axios.post(`${adminURL}/tenant-billings`, filterObject, { headers: { Authorization: `Bearer ${apiToken}` }});
    };

    // SALES
    // SOON TO COME (Create Tenants w/ commission logging)

    // ADMIN USERS
    login = async (email, password) => {
        return axios.post(`${adminURL}/login`, { email, password });
    };

    getAdminUsers = async (apiToken, filterObject) => {
        return axios.post(`${adminURL}/admin-users`, filterObject, { headers: { Authorization: `Bearer ${apiToken}` }});
    };

    createUser = async (apiToken, userObject) => {
        return axios.post(`${adminURL}/admin-user`, userObject, { headers: { Authorization: `Bearer ${apiToken}` }});
    };

    updateUser = async (apiToken, userId, userObject) => {
        return axios.put(`${adminURL}/admin-user/${userId}`, userObject, { headers: { Authorization: `Bearer ${apiToken}` }});
    };

}

const adminService = new AdminService();
export default adminService;